import React from 'react';
import { BsExclamationTriangle } from 'react-icons/bs';

const ErrorState = ({ message, onRetry }) => (
    <div className="list-empty-state list-error-state">
        <span className="list-empty-icon"><BsExclamationTriangle /></span>
        <h6 className="list-empty-title">No Details Found</h6>
        <p className="list-empty-desc">{message || "We couldn't load the data. Please try again."}</p>
        {onRetry ? (
            <button type="button" className="btn btn-outline-danger btn-sm" onClick={onRetry}>Try again</button>
        ) : ""}
    </div>
);

export default ErrorState;
